import styles from './ReferralBannerDesktop.scss';

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getReferrer } from 'src/components/SalesChannel/Util';
import { formatPhonePattern } from '../Contact/regex';
import { ScrollDirection } from '../NavBar/NavBarUtil';
import { referralInfo, transformBanner } from './ReferralBannerUtils';

export type Props = {
  mainContentRef?: any;
  navHeight: string;
  paddingTop: string;
  scrollDirection?: ScrollDirection;
  wrapperGroupRef?: any;
};

export const ReferralBannerDesktop: React.FC<Props> = ({ mainContentRef, navHeight, paddingTop, scrollDirection, wrapperGroupRef }) => {
  const desktopBannerRef = React.createRef<HTMLDivElement>();
  const { t } = useTranslation();
  const { referrerName, referrerEmail, referrerPhone } = referralInfo(JSON.parse(getReferrer() || '{}'));
  const emailRef = `mailto:${referrerEmail}`;
  const phoneRef = `tel:${referrerPhone}`;

  useEffect(() => {
    const desktopBannerCurrent = desktopBannerRef.current;
    const mainContentCurrent = mainContentRef?.current;
    const wrapperGroupCurrent = wrapperGroupRef?.current;
    if (!mainContentCurrent || !desktopBannerCurrent) return;
    transformBanner(desktopBannerCurrent, mainContentCurrent, navHeight, paddingTop, scrollDirection, wrapperGroupCurrent);
  }, [desktopBannerRef]);

  return (
    <div ref={desktopBannerRef} className={styles.referralBanner}>
      <div className={styles.referralBannerContent}>
        <span>{t('contact-your-rep')}</span>
        <span>{referrerName}</span>
        {referrerEmail && <>| <a className="referrer-email" href={emailRef}>{referrerEmail}</a></>}
        {referrerPhone && <>| <a className="referrer-phone" href={phoneRef}>{referrerPhone.replace(formatPhonePattern, '($1) $2-$3')}</a></>}
      </div>
    </div>
  );
};
